module.exports = __webpack_public_path__ + "7d470a484566c051a5209b455d59dfa3.svg";